const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '2025年度娱乐圈十大惊天爆料回顾',
    desc: '从年初到年中，娱乐圈风波不断，我们整理了今年最具爆炸性的十大爆料事件，每一个都曾引爆全网热议。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%2C%20abstract%20year%20in%20review%20concept%2C%20soft%20coral%20and%20cream%20tones%2C%20clean%20minimalist%20studio%20background%2C%20magazine%20quality%20layout%20aesthetic%2C%20suggesting%20entertainment%20news%20retrospective%2C%20professional%20photography%2C%20warm%20ambient%20lighting%2C%20no%20text%20visible&width=800&height=500&seq=carousel-feature-01&orientation=landscape',
  },
  {
    id: 2,
    title: '网红经济大洗牌：头部主播集体转型之路',
    desc: '随着行业监管趋严和流量红利见顶，头部网红们纷纷寻求转型，有的跨界影视，有的投身实业，网红经济正在经历深刻变革。',
    tag: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%2C%20warm%20amber%20lighting%2C%20abstract%20digital%20economy%20transformation%20theme%2C%20clean%20minimalist%20background%2C%20suggesting%20influencer%20economy%20shift%2C%20magazine%20editorial%20quality%2C%20soft%20shadows%2C%20professional%20composition%2C%20warm%20tones%2C%20no%20text&width=800&height=500&seq=carousel-feature-02&orientation=landscape',
  },
  {
    id: 3,
    title: '吃瓜文化进化论：从贴吧到短视频的爆料变迁',
    desc: '回顾吃瓜文化的演变历程，从论坛时代的文字爆料到短视频平台的实锤视频，爆料方式和传播路径发生了翻天覆地的变化。',
    tag: '文化观察',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%2C%20abstract%20digital%20culture%20evolution%20concept%2C%20soft%20coral%20accents%2C%20clean%20minimalist%20background%2C%20suggesting%20internet%20culture%20history%2C%20magazine%20quality%2C%20professional%20photography%2C%20warm%20ambient%20lighting%2C%20no%20text%2C%20harmonious%20composition&width=800&height=500&seq=carousel-feature-03&orientation=landscape',
  },
  {
    id: 4,
    title: '明星工作室公关策略大揭秘：谁在掌控舆论？',
    desc: '深入解析娱乐圈背后的公关运作机制，从危机公关到舆论引导，揭秘明星团队如何应对各种爆料和负面新闻。',
    tag: '幕后揭秘',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%2C%20warm%20amber%20lighting%2C%20abstract%20public%20relations%20strategy%20concept%2C%20clean%20minimalist%20background%20with%20warm%20gradient%2C%20suggesting%20PR%20and%20media%20management%2C%20magazine%20quality%2C%20professional%20photography%2C%20soft%20shadows%2C%20no%20text%2C%20warm%20tones&width=800&height=500&seq=carousel-feature-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            本周重磅专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            编辑精选深度内容，带你全方位了解吃瓜世界的台前幕后
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-background-300/80 transition-all cursor-pointer"
            >
              <div className="sm:w-[45%] shrink-0 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width="800"
                  height="500"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block self-start px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}